import React, { useEffect, useState, createContext, useContext, useCallback, SetStateAction } from "react";
import { UserContext } from "@ipd/js-common";
import { Data } from "../typescript/interfaces/context";
import { normalize, sort } from "../functions";
import config from "../config";
import { ComplexFormTypeDescription } from "../typescript/interfaces/data";

const DataContext = createContext<[Array<Data>, Function, Array<ComplexFormTypeDescription>]>([[], () => {}, []]);

const DataProvider = ({ children }) => {
  const [state, setState] = useState<[Data[], ComplexFormTypeDescription[]]>([[], []]);
  const { token } = useContext(UserContext);

  useEffect(() => {
    if (token) {
      (async (): Promise<void> => {
        const cacheResponse = await fetch(config.CACHE_URL, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const { url } = await cacheResponse.json();

        const s3Response = await fetch(url);
        const { data } = await s3Response.json();

        const cfData = data["complexFormTypeDescriptions"] as ComplexFormTypeDescription[];
        const normalizedData = normalize.usaClinicalPipelineTearsheets(data["USAClinicalPipelineTearsheets"]);
        const sorted = sort.rowsByStages(normalizedData);
        setState([sorted, cfData]);
      })();
    }
  }, [token]);

  // for easier back-compat, keep cfData separate
  const setDataState: React.Dispatch<SetStateAction<Data[]>> = useCallback(
    () => (value: Data[]) => setState((prev) => [value, prev[1]]),
    [setState]
  );
  return <DataContext.Provider value={[state[0], setDataState, state[1]]}>{children}</DataContext.Provider>;
};

export { DataContext, DataProvider };
